import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import { useGetPortalWorkspacesQuery } from 'src/features/manage-clients/users/endpoints/portal-users.endpoints';

interface UsageInsightsFilterBarProps {
  from: string;
  to: string;
  workspaceId: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
  onWorkspaceIdChange: (value: string) => void;
}

export function UsageInsightsFilterBar({
  from,
  to,
  workspaceId,
  onFromChange,
  onToChange,
  onWorkspaceIdChange,
}: UsageInsightsFilterBarProps) {
  const { data: workspacesData } = useGetPortalWorkspacesQuery({ page_size: 200 });
  const workspaceOptions = workspacesData?.results ?? [];

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-[#EDEEF2] bg-white p-4 lg:flex-row lg:flex-wrap lg:items-end">
      <label className={cn(portalDs.field, 'min-w-[180px]')}>
        <span className={portalDs.filterLabel}>From</span>
        <input
          type="date"
          className={portalDs.input}
          value={from}
          onChange={(event) => onFromChange(event.target.value)}
        />
      </label>

      <label className={cn(portalDs.field, 'min-w-[180px]')}>
        <span className={portalDs.filterLabel}>To</span>
        <input
          type="date"
          className={portalDs.input}
          value={to}
          onChange={(event) => onToChange(event.target.value)}
        />
      </label>

      <label className={cn(portalDs.field, 'min-w-[220px] flex-1')}>
        <span className={portalDs.filterLabel}>Workspace</span>
        <select
          className={portalDs.select}
          value={workspaceId}
          onChange={(event) => onWorkspaceIdChange(event.target.value)}
        >
          <option value="">All workspaces</option>
          {workspaceOptions.map((workspace) => (
            <option key={workspace.workspace_id} value={workspace.workspace_id}>
              {workspace.workspace_name || workspace.workspace_id}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
